import React from "react"
import Chart from "react-apexcharts"

const PieChart = ({ series, labels }) => {
  const colors = [
    "#6C63FF", // indigo
    "#F97316", // orange
    "#10B981", // green
    "#3B82F6", // blue
    "#EF4444", // red
    "#8B5CF6", // purple
    "#14B8A6", // teal
    "#F59E0B", // amber
    "#EC4899", // pink
    "#22C55E", // light green
  ]

  const options = {
    chart: {
      type: "pie",
      background: "transparent",
      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 900,
        animateGradually: { enabled: true, delay: 150 },
      },
      dropShadow: {
        enabled: true,
        top: 4,
        blur: 12,
        opacity: 0.15,
      },
    },
    labels,
    colors,
    legend: {
      position: "right",
      fontSize: "11px",
      offsetY: -5,
      fontWeight: 600,
      labels: { colors: "#475569" },
      markers: { width: 10, height: 10, radius: 50 },
      itemMargin: { horizontal: 12, vertical: 6 },
    },
    dataLabels: {
      enabled: true,
      formatter: val => `${val.toFixed(1)}%`,
      style: {
        fontSize: "12px",
        fontWeight: 700,
        colors: ["#fff"],
      },
      dropShadow: { enabled: true, blur: 4, opacity: 0.3 },
    },
    stroke: {
      width: 2,
      colors: ["#ffffff"],
    },
    fill: {
      opacity: 1, // ✅ changed from 0.85 — pie looks better at full opacity
    },
    // ✅ removed polarArea plotOptions — not applicable for pie
    tooltip: {
      theme: "dark",
      style: { fontSize: "12px" },
      y: {
        formatter: val => `£${val.toLocaleString("en-GB")}`,
      },
    },
    states: {
      hover: { filter: { type: "lighten", value: 0.08 } },
      active: { filter: { type: "darken", value: 0.15 } },
    },
  }

  const total = series?.reduce((a, b) => a + b, 0)

  return (
    <div
      style={{
        background: "linear-gradient(145deg, #ffffff 0%, #f8faff 100%)",
        borderRadius: "16px",
        padding: "20px 16px 12px",
        boxShadow:
          "0 4px 24px rgba(108,99,255,0.08), 0 1px 4px rgba(0,0,0,0.04)",
        border: "1px solid #ede9fe",
        position: "relative",
        overflow: "hidden",
        height: "100%",
      }}
    >
      {/* Top accent bar */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "3px",
          background: "linear-gradient(90deg, #6C63FF, #F97316, #10B981)",
          borderRadius: "16px 16px 0 0",
        }}
      />
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "4px",
          padding: "0 8px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #6C63FF, #F97316)",
              boxShadow: "0 0 8px #6C63FF88",
            }}
          />
          <span style={{ fontSize: "15px", fontWeight: 700, color: "#1e293b" }}>
            Contribution by Customer
          </span>
        </div>
        {/* Total badge */}
        <div
          style={{
            background: "linear-gradient(135deg, #6C63FF15, #F9731615)",
            border: "1px solid #ede9fe",
            borderRadius: "20px",
            padding: "3px 10px",
            fontSize: "14px",
            fontWeight: 700,
            color: "#6C63FF",
          }}
        >
          £{total?.toLocaleString("en-GB")}
        </div>
      </div>

      {/* ✅ type changed to "pie" */}
      <Chart type="pie" options={options} series={series} height={360} />
    </div>
  )
}

export default PieChart
